import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e49d874"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "fixed ms-1",
  style: {"width":"150px"}
}
const _hoisted_2 = {
  key: 1,
  class: "fixed ms-1",
  style: {"width":"300px"}
}
const _hoisted_3 = {
  key: 2,
  class: "fixed ms-1",
  style: {"width":"300px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isSingleSelect)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Multiselect, {
            modelValue: _ctx.selected,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected) = $event)),
            placeholder: _ctx.filter.title,
            options: _ctx.filterValues,
            canClear: false,
            class: "multiselect-blue",
            style: {"width":"150px"},
            onSelect: _ctx.onSelect
          }, null, 8, ["modelValue", "placeholder", "options", "onSelect"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isMultiSelect)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Multiselect, {
            modelValue: _ctx.selected,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selected) = $event)),
            placeholder: _ctx.filter.title,
            mode: "tags",
            options: _ctx.filterValues,
            canClear: false,
            class: "multiselect-blue",
            style: {"width":"300px"},
            onSelect: _ctx.onSelect,
            onDeselect: _ctx.onSelect
          }, null, 8, ["modelValue", "placeholder", "options", "onSelect", "onDeselect"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isAutoComplete)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_Multiselect, {
            modelValue: _ctx.selected,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selected) = $event)),
            placeholder: _ctx.filter.title,
            searchable: true,
            options: _ctx.filterValues,
            class: "multiselect-blue",
            style: {"width":"300px"},
            onSelect: _ctx.onSelect,
            onDeselect: _ctx.onSelect
          }, null, 8, ["modelValue", "placeholder", "options", "onSelect", "onDeselect"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}